var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYandexMirrorsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.402 2.5h15.196a3 3 0 0 0-1.236-1.173C17.72 1 16.88 1 15.2 1H8.8c-1.68 0-2.52 0-3.162.327A3 3 0 0 0 4.402 2.5z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5.5h17a3 3 0 0 0-1.236-1.173C18.622 4 17.782 4 16.102 4H7.898c-1.68 0-2.52 0-3.162.327A3 3 0 0 0 3.5 5.5z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 11.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 7 5.12 7 6.8 7h10.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v5.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 22 18.88 22 17.2 22H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 19.72 2 18.88 2 17.2v-5.4zm3.25-2.3a.75.75 0 1 0 0 1.5h1.5a.75.75 0 0 0 0-1.5h-1.5zm3.75 5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandexMirrorsIcon);
export default __webpack_public_path__ + "static/media/yandex_mirrors_icon.bad10981f2aa7f8c0f88395a0190a50f.svg";
export { ForwardRef as ReactComponent };